<template id="input">
    <div
        class="field-wrapper field-wrapper--floating-label"
        :class="classList"
        v-if="inputConfig.type !== 'hidden'">
        <cleave
            v-model="birthday"
            :options="options"
            :value="inputConfig.value"
            :id="inputConfig.id || inputConfig.name"
            :class="inputConfig.styleClass"
            :placeholder="inputConfig.placeholderMsg"
            type="text"
            :tabindex="inputConfig.tabIndex"
            :ref="inputConfig.ref"
            :data-recurly="inputConfig.dataRecurly"
            @input="onInput"
            @input.native="handleInputNative"
            @keydown.native="handleKeydownNative"
            @focus.native="focused = true"
            @blur="onBlur"
            :name="inputConfig.name"
            :aria-required="this.ariaRequired"></cleave>
        <label :class="{ floated: hasValue }" :for="inputConfig.id || inputConfig.name">
            {{ inputConfig.label }}
        </label>
    </div>
</template>

<script>
    import Cleave from 'vue-cleave-component';

    export default {
        props: {
            inputConfig: Object,
            errorMessage: {
                type: String,
                required: false,
            },
        },

        data: function () {
            return {
                focused: false,
                value: this.inputConfig.value,
                specialValue: this.inputConfig.value || '',
                birthday: this.inputConfig.value,
                options: {
                    birthday: true,
                    delimiter: '/',
                    date: true,
                    datePattern: ['m', 'd', 'Y'],
                },
                keyupListener: null,
                focusListener: null,
                ariaRequired: true,
            };
        },

        created: function () {
            this.$emit('input', {
                value: this.inputConfig.value,
            });
        },
        methods: {
            onInput(e) {
                this.$emit('input', {
                    value: this.birthday,
                });
            },

            handleInputNative(event) {
                // only listen to key that has value
                if (!event.data) {
                    return;
                }

                if (event.data.charCodeAt() != this.options.delimiter.charCodeAt()) {
                    return;
                }

                this.formatDate();
            },

            handleKeydownNative(event) {
                if (event.key != this.options.delimiter) {
                    return;
                }

                this.formatDate();
            },

            onBlur(e) {
                this.focused = false;
                this.specialValue = this.$refs[this.inputConfig.ref].value;

                this.$emit('blur');
            },

            /**
             * auto advance month and day when user enters the delimiter charater set in
             * the Cleve plugin option.
             *
             * @example returns 01 when user enters 1 in month, then '/'
             * @example returns 03 when user enters 3 in day, then '/'
             */
            formatDate() {
                if (this.birthday == null) {
                    return;
                }

                // Format month
                if (this.birthday.length == 1 && this.birthday == 1) {
                    this.birthday = '01';
                    return;
                }
                // Format day
                if (this.birthday.length == 3 && this.birthday.slice(-1) < 4) {
                    this.birthday = this.birthday.slice(0, -1) + '0' + this.birthday.slice(-1);
                    return;
                }

                return;
            },
        },

        computed: {
            hasValue: function () {
                return this.specialValue;
            },
            classList: function () {
                return [
                    'field-wrapper--' + this.inputConfig.id,
                    this.focused ? 'focused' : '',
                    this.errorMessage ? 'error' : '',
                ];
            },
        },

        components: {
            Cleave,
        },
    };
</script>
